import { useContext } from "react";
import { QuantityContext } from "./QuantityContext";

const useQuantity = () => {
  return useContext(QuantityContext);
};

export default useQuantity;
